(() => {
  /* gift note -> cart note */
  let noteTimer, notePending = null;
  const saveNote = v => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) });
  document.addEventListener('input', e => {
    if (e.target.id !== 'cartNote') return;
    clearTimeout(noteTimer); const v = e.target.value;
    noteTimer = setTimeout(() => { notePending = saveNote(v); }, 400);
  });
  document.addEventListener('submit', async e => {
    const n = document.getElementById('cartNote'); if (!n || !e.target.closest('#cartFoot')) return;
    e.preventDefault(); clearTimeout(noteTimer);
    try { if (notePending) await notePending; await saveNote(n.value); } catch (_) {}
    const f = e.target; const h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.appendChild(h); f.submit();
  });

  /* product page holiday notes */
  let H = {}; try { H = JSON.parse(document.getElementById('pbbHoliday').textContent) || {}; } catch (_) {}
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const sec = document.querySelector('[data-product-section]');
  if (sec) {
    const mto = sec.dataset.mto === 'true', kind = sec.dataset.kind;
    const band = sec.querySelector('.mto-band');
    if (mto && H.mto && band) {
      const p = document.createElement('p'); p.className = 'hol-note';
      p.innerHTML = esc(H.mto) + (H.link ? ` <a class="link" href="${esc(H.link)}">Shop Bond Boots</a>` : '');
      band.after(p);
    }
    const ul = sec.querySelector('.assure');
    if (!mto && kind !== 'limited' && H.cutoff && ul) {
      const li = document.createElement('li');
      li.innerHTML = `<span><b>Holiday delivery.</b> ${esc(H.cutoff)}</span>`;
      ul.insertBefore(li, ul.children[1] || null);
    }
  }
})();
